import React from 'react';
import { NavLink as RouteNavLink, NavLinkProps } from 'react-router-dom';
import cx from 'clsx';

export const NavLink = ({
  onClick,
  disabled,
  disabledClassName,
  className,
  ...rest
}: NavLinkProps & {
  disabled?: boolean;
  disabledClassName?: string;
}) => {
  const handleClick = (e: any) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <RouteNavLink
      onClick={handleClick}
      className={cx(className, disabled && disabledClassName)}
      {...rest}
    />
  );
};
